// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import grey from "@material-ui/core/colors/grey"

// GRAPHQL
// eslint-disable-next-line
import crossFetch from "cross-fetch"

import {
    writeFback,
    genUrl    
} from "../../bl/A/bl"

// UTILS
import * as _ from "lodash"

// FLASH
//import FlashLogo from "../../static/images/lightning-logo-transparent.png";
import FlashLogo from "../../static/images/pulseai/pulseai.logo3.transparent.png";

// import FlashBottomBar from "../Flash/FlashBottomBar.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"
// import LogRocket from 'logrocket'
import Typography from "@material-ui/core/Typography"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Submit>")
//LogRocket.init('sbqpcc/flashdev')

const styles = theme => ({
    appbarRoot: {
        height: 50
    },

    appbarMessage: {
        padding: 8,
    },

    appheadRoot: {
        height: 50,
        marginTop: 50,
        background: grey[270],
        border: "none",
        boxShadow: "none",
        zIndex: 0,
    },

    bnavbarRoot: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: grey[300],
    },

    
    appheadMessage: {
        padding: 8,
        width: "100%",
        textAlign: "center",
        fontWeight: 600,
    },

    contentDiv: {
        padding: 0,
        marginTop: 60,
        marginBottom: 50,
    },

    profileButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    continueButton: {
        margin: 20,
        padding: 8,
        width: 200,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    welcomeMessage: {
        marginTop: 20,
        // mobile
        // fontSize is working
        [theme.breakpoints.down("sm")]: {
            fontSize: 30,
        },
    },

    mobileAppIcon: {
        display: "none", // show only in mobile
        [theme.breakpoints.down("sm")]: {
            display: "block",
            margin: "0 auto",
            paddingTop: 30,
        },
    },


    logoutDiv: {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center
    },

    animationDiv: {
        display: "flex",
        flexDirection: "column",
        
        width: 300,
        height: 300,
//        backgroundColor: green[100],

        alignItems: "center", // vertical center
        justifyContent: "center", // horizontal center

        animationName: "$logoutAnimation",
        animationDuration: "2s",
        animationFillMode: "forwards",

        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            animationName: "$logoutAnimationDesktop",
        },
    },

    "@keyframes logoutAnimation":  {
        "0%": {
            opacity: 0,
            fontSize: 12,
            height: 200,
            width: 200,
        },

        // fade in so that icon does not "blink"
        "10%": {
            opacity: 0.5,
            fontSize: 12,
            height: 200,
            width: 200,
        },
       
        "100%": {
            opacity: 1,
            fontSize: 20,
            height: 400,
            width: 400,
        },

    },

    //
    // desktop
    //
  "@keyframes logoutAnimationDesktop":  {
      "0%": {
          opacity: 0, 
          fontSize: 15,
          height: 300,
          width: 300,
      },

      "1%": {
          opacity: 0.2,
          fontSize: 15,
          height: 300,
          width: 300,
      },
      
      "100%": {
          opacity: 1,
          marginTop: 0,
          fontSize: 30,
          height: 500,
          width: 500,
      },

    },


    navDiv: {
        position: "fixed",
        bottom: 0,
        width: "100%",
        zIndex: 1000,
//        backgroundColor: grey[200],

//        height: 72,
//        borderTop: "1px solid",
//        borderTopColor: grey[300],
//	borderRadius: 0,
    },
    
})


class Submit extends Component {

    constructor() {
        super()
        log.debug("constructor()")

        this.state = {
            redirectBack: false,
            redirectContinue: false,
            redirectToIssues: false,
        }

        
    }
    
    handleCloseClick = () => {
        log.debug("handleCloseClick()")

        this.setState({redirectLogout: true})
    }

    handleIssueClick = () => {
        log.debug("handleIssueClick()")

        let checkedContacts = _.filter(this.state.gl.contacts, ["isChecked", true])
        log.debug("handleIssueClick(): checkedContacts = ", checkedContacts)

        _.map(checkedContacts, (contact) =>{
            // uncheck if checked
            contact.isChecked ? contact.isChecked = false : contact.isChecked = true
        })

        log.debug("handleIssueClick(): unchecked checkedContacts = ", checkedContacts)

        localStorage.setItem("gl", JSON.stringify(this.state.gl))
        
        this.setState({redirectToIssues: true})
    }

    
    handleProfileClick = () => {
        log.debug("handleProfileClick()")
        this.setState({redirectToProfile: true})
    }

    handleContinueClick = () => {
        log.debug("handleContinueClick()")
        this.setState({redirectToContacts: true})
    }
    
    UNSAFE_componentWillMount_old = () => {
        log.debug("componentWillMount()")
        let localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("componentWillMount(): localGL = ", localGL)
        
        this.setState({
            gl: localGL,
        })
    }

    componentDidMount = () => {
        log.debug("componentDidMount()")

        const localGL = JSON.parse(localStorage.getItem("gl"))
        log.debug("componentDidMount(): localGL = ", localGL)

        if(!localGL) {
            log.debug("constructor(): WARNING: no localGL, to fback to send, return early")
            return
        }

        if(!localGL.currentIssue) {
            log.debug("constructor(): WARNING: no localGL.currentIssue, to fback to send, return early")
            return 
        }

        const checkedStatements = _.filter(localGL.statements, ["isChecked", true])

        log.debug("componentDidMount(): will be sending fback for checkedItems =", checkedStatements)
        log.debug("componentDidMount(): will be sending fback for localGL.currentIssue =", localGL.currentIssue)
        
        /*
	       let fback = {
		   "user": user,
		   "set": set,
		   "statements": [
		       {"uuid": "00000000-0000-0000-0000-000000000333",
			"slug": "us-votebymail-statement-1",
			"rank": "1"
		       },
		       {"uuid": "00000000-0000-0000-0000-000000000333",
			"slug": "us-votebymail-statement-2",
			"rank": "2"
		       }
		   ]
	       }

        */

	const set = {"slug": "written-by-flash","uuid": "00000000-0000-0000-0000-000000000555","userCount":1,"fbackUserCount": null,"weight":null,"weightSum":null,"weightNorm": null,"tags": ["devshell", "fback-set-tag"]}
        
        const fback = {
            user: {
                "uuid": localGL.user.uuid,
                "slug": localGL.user.slug,
            },
	    set: set,
            // reduce the fields to minimum that we need
            issue: {
                sentiment: localGL.currentIssue.sentiment
            },
            statements: checkedStatements.map(s => {
                return {
                    uuid: s.uuid,
                    slug: s.slug,
                    rank: s.rank
                }
            })
        }

	const handleResult = (result) => {
	    log.debug("componentDidMount(): writeFback(): handleResult(): SUCCESS: result = ", result)
	}

	const handleError = (error) => {
	    log.debug("componentDidMount: writeFback(): handleResult(): ERROR: error = ", error)
	}
        
        log.debug("componentDidMount(): fback =", fback)

	writeFback(fback, {
	    onResult: handleResult,
	    onError: handleError
	})
        
    }
    
        
    render() {
        const { classes } = this.props

        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/summary"/>
        } else if(this.state.redirectLogout) {
            return <Redirect push to="/logout"/>
        } else if(this.state.redirectToIssues) {
            return <Redirect push to="/contacts"/>
        } else if(!this.state || !this.state.gl || !this.state.gl.currentIssue) {
            // all the way home after logout
            // DEBUG only
            // return <Redirect push to="/"/>
        }

        //        let redirectLink = "/contacts" // default return spot
        let redirectLink = "/issues" // default return spot

        let drive = JSON.parse(localStorage.getItem("drive"))
        if(drive && drive.slug) {
            // redirectLink = `/drives/${drive.slug}/issues`
            redirectLink = genUrl(this)("/issues")
        }

        localStorage.removeItem("isFirstLogon")
        
	return(
            <React.Fragment>
	      <CssBaseline/>
              <div className={classes.contentDiv}>
                <div className={classes.logoutDiv}>
                  <div className={classes.animationDiv}>
                    <div style={{position: "relative", width: "100%", height: "50%", textAlign: "center"}}>
                      {/* put this puppy on the bottom and in the center */}
                      <div style={{position: "absolute", bottom: 0, marginLeft: "auto", marginRight: "auto", left: 0, right: 0}}>
                        <img alt="logo" src={FlashLogo} style={{width: "80%"}}/>
                      </div>            
                    </div>            
                    <div style={{width: "100%", height: "50%", textAlign: "center"}}>
                      You'll be heard and have an impact!
                    </div>
                  </div>
                </div>
              </div>

            {/*
              <FlashBottomBar
//                backButton={{
//                    text: "FINISH",
//                    link: "/logout",
//                    //                    onClick: this.handleBack
//                }}
                nextButton={{
                    text: "ADDRESS ANOTHER ISSUE",
//                    text: "NEXT",
                    link: "/contacts",
                    onClick: this.handleNext,
                    onError: this.handleError,
                }}/>
             */}
              
              <div className={classes.navDiv}>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                  <Typography className={classes.subheaderText} variant="h6" style={{marginLeft: "10%", marginRight: "10%"}}>
                    This issue will not appear
                  </Typography> 
                  <Typography className={classes.subheaderText} variant="h6">
                    on the list again for 10 days...
                  </Typography>
                </div>
                <FlashBottomPad
                  nextButton={{
                      text: "ADDRESS ANOTHER ISSUE",
                      link: redirectLink,
                  }}
                />
              </div>
              
            </React.Fragment>
	)
    }
}

Submit.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Submit" })(Submit)

